export interface DonutChartData {
  value: string;
  label: string;
  colors: object;
  columns: (string | number)[][];
}

export enum DonutChartWidgetEvents {
  SLICE_CLICK = 'donut-chart-widget-slice-click',
}

export interface ChartSliceClickInfo {
  id: string;
  name: string;
  value: number;
  index: number;
  ratio: number;
}
